import { LabMDM } from "./lab";

export class ExternalSenderLoginDTO{
    _id : string;
    version : number;
    lab : LabMDM;
    puid : string;
    name : string;
}